import { useEffect } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import DatePicker from "react-datepicker";
import useAppDispatch from "../hooks/useAppDispatch";
import useAppSelector from "../hooks/useAppSelector";
import {
  getBusAttendances,
  setSelectedBusAttendance,
} from "../redux/module/busAttendances";
import {
  // setAccuracy,
  setDate,
  setShowBusStops,
  setShowPickedUp,
  setStopTime,
} from "../redux/module/controls";

const Controls = () => {
  const dispatch = useAppDispatch();
  const showBusStops = useAppSelector((state) => state.controls.showBusStops);
  const showPickedUp = useAppSelector((state) => state.controls.showPickedUp);
  const stopTime = useAppSelector((state) => state.controls.stopTime);
  const date = useAppSelector((state) => state.controls.date);
  // const accuracy = useAppSelector((state) => state.controls.accuracy);
  const busAttendances = useAppSelector(
    (state) => state.busAttendances.busAttendances
  );
  const selectedBusAttendance = useAppSelector(
    (state) => state.busAttendances.selectedBusAttendance
  );

  useEffect(() => {
    dispatch(getBusAttendances(date));
  }, [dispatch, date]);

  const handleBusAttendanceChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const id = e.target.value;
    const busAttendance =
      id && busAttendances.find((item) => item.busAttendanceId === id);

    dispatch(setSelectedBusAttendance(busAttendance || null));
  };

  return (
    <>
      <DatePicker
        onChange={(date) => date && dispatch(setDate(date.toISOString()))}
        selected={new Date(date)}
        dateFormat="MM/dd/yyyy"
        className="form-control mb-2"
      />
      <Form.Select
        className="mb-2"
        onChange={handleBusAttendanceChange}
        value={selectedBusAttendance?.busAttendanceId || ""}
      >
        <option value="">All</option>
        {busAttendances.map((busAttendance) => (
          <option
            key={busAttendance.busAttendanceId}
            value={busAttendance.busAttendanceId}
          >
            {busAttendance.busRoute}
          </option>
        ))}
      </Form.Select>
      <Row className="mb-2">
        <Col>
          <Form.Check
            id="show-bus-stops"
            checked={showBusStops}
            onChange={(e) => dispatch(setShowBusStops(e.target.checked))}
            label="Show bus stops"
          />
        </Col>
        <Col>
          <Form.Check
            id="show-picked-up-places"
            checked={showPickedUp}
            onChange={(e) => dispatch(setShowPickedUp(e.target.checked))}
            label="Show picked up"
          />
        </Col>
      </Row>
      <Row className="mb-2 align-items-center">
        <Col xxl="auto" xs="auto">
          <Form.Label htmlFor="stop-time">Stop Time:</Form.Label>
        </Col>
        <Col>
          <Form.Control
            id="stop-time"
            type="number"
            value={stopTime}
            onChange={(e) => dispatch(setStopTime(+e.target.value))}
            disabled={!showBusStops}
          />
        </Col>
      </Row>
      {/* <Row className="mb-2 align-items-center">
        <Col xxl="auto" xs="auto">
          <Form.Label htmlFor="accuracy">Accuracy:</Form.Label>
        </Col>
        <Col>
          <Form.Control
            id="accuracy"
            type="number"
            value={accuracy}
            onChange={(e) => dispatch(setAccuracy(+e.target.value))}
          />
        </Col>
      </Row> */}
    </>
  );
};

export default Controls;
